(function () {
  function starsMarkup() {
    var star =
      '<svg viewBox="0 0 20 20" width="14" height="14" fill="currentColor"><path d="M10 1.5l2.6 5.4 5.9.8-4.3 4.1 1 5.9L10 14.9l-5.2 2.8 1-5.9-4.3-4.1 5.9-.8L10 1.5z"/></svg>';
    return star.repeat(5);
  }

  function init(imageUrls) {
    var iconsRow = document.querySelector(".icons-row");
    if (!iconsRow) return;

    var section = document.createElement("section");
    section.className = "c-v-pro-hp-10";
    section.setAttribute("data-section-type", "c-v-pro-hp-10");
    section.innerHTML =
      '<div class="wrapper">' +
      '<div class="c-v-pro-hp-10__header">' +
      '<h2 class="c-v-pro-hp-10__title">What makes PRO Compression different!</h2>' +
      '<div class="c-v-pro-hp-10__badge">' +
      '<span class="c-v-pro-hp-10__stars" aria-hidden="true">' + starsMarkup() + "</span>" +
      '<span class="c-v-pro-hp-10__badge-text">23,000+ REVIEWS</span>' +
      "</div>" +
      "</div>" +
      '<div class="c-v-pro-hp-10__image">' +
      '<img class="c-v-pro-hp-10__image--desktop" src="' +
      imageUrls.desktop +
      '" alt="PRO Compression vs other brands comparison" width="4716" height="2928" loading="lazy">' +
      '<img class="c-v-pro-hp-10__image--mobile" src="' +
      imageUrls.mobile +
      '" alt="PRO Compression vs other brands comparison" width="1492" height="3600" loading="lazy">' +
      "</div>" +
      "</div>";

    iconsRow.insertAdjacentElement("afterend", section);
  }

  function getImageUrls() {
    var dataEl = document.getElementById("c-v-pro-hp-10-data");
    if (!dataEl) return null;
    try {
      return JSON.parse(dataEl.textContent);
    } catch (e) {
      return null;
    }
  }

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  ready(function () {
    var imageUrls = getImageUrls();
    if (imageUrls) init(imageUrls);
  });
})();
